import { Button } from "@website/ui/button";
import { useCta } from "@website/ui/datepicker/components/cta/cta.hook";
import styles from "@website/ui/datepicker/components/cta/cta.module.scss";
import { CtaPropertiesType } from "@website/ui/datepicker/components/cta/cta.types";
import { FC, memo } from "react";

const Cta: FC<CtaPropertiesType> = (properties) => {
  const { view } = properties;

  const { acceptButtonProperties, rejectButtonProperties } = useCta(properties);

  return (
    <div
      className={`${styles["container"]} ${
        view === "mobile"
          ? "justify-center"
          : "justify-center lg:ml-0 lg:mr-auto lg:justify-end"
      }`}
    >
      <Button {...rejectButtonProperties} className={styles["reject-button"]}>
        پاک کردن
      </Button>
      <Button {...acceptButtonProperties} className={styles["accept-button"]}>
        تایید
      </Button>
    </div>
  );
};

const CtaMemoized = memo(Cta);
export { CtaMemoized as Cta };
